// extracted by mini-css-extract-plugin
module.exports = {"activityPage":"activityPage__9GvXS"};